const PROGRAMS_ASSETS_BASE_URL = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/programs';

const getProgramGuideImageUrl = (filename: string) => `${PROGRAMS_ASSETS_BASE_URL}/${filename}`;

export const programGuideImages = {
  family: {
    light: getProgramGuideImageUrl('family-light.webp'),
    dark: getProgramGuideImageUrl('family-dark.webp'),
  },
  it: {
    light: getProgramGuideImageUrl('it-light.webp'),
    dark: getProgramGuideImageUrl('it-dark.webp'),
  },
  base: {
    light: getProgramGuideImageUrl('base-light.webp'),
    dark: getProgramGuideImageUrl('base-dark.webp'),
  },
} as const;
